import type { Office, ThemeData } from '../types';

export function getOffice(level: number, themeData: ThemeData): Office {
  const def = themeData.entities.offices.find((o) => o.level === level);
  if (!def) {
    throw new Error(`No office definition for level ${level}`);
  }

  return {
    level: def.level,
    name: def.name,
    maxStaff: def.maxStaff,
    maxTeams: def.maxTeams,
    maxConcurrentProjects: def.maxConcurrentProjects,
    weeklyRent: def.weeklyRent,
    upgradeCost: def.upgradeCost,
    perks: [...def.perks],
  };
}

export function getMaxOfficeLevel(themeData: ThemeData): number {
  return Math.max(...themeData.entities.offices.map((o) => o.level));
}
